"use strict";
/*
This file is part of web3.js.

web3.js is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

web3.js is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressCoder = void 0;
const address_1 = require("@ethersproject/address");
const bytes_1 = require("@ethersproject/bytes");
const web3_utils_1 = require("@theqrl/web3-utils");
const abstract_coder_js_1 = require("./abstract-coder.js");
class AddressCoder extends abstract_coder_js_1.Coder {
    constructor(localName) {
        super('address', 'address', localName, false);
    }
    defaultValue() {
        return 'Q0000000000000000000000000000000000000000';
    }
    encode(writer, value) {
        try {
            value = (0, address_1.getAddress)((0, web3_utils_1.addressToHex)(value));
        }
        catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, web3_utils_1.hexToAddress)((0, address_1.getAddress)((0, bytes_1.hexZeroPad)(reader.readValue().toHexString(), 20)));
    }
}
exports.AddressCoder = AddressCoder;
//# sourceMappingURL=address.js.map